module.exports = __webpack_public_path__ + "img/case_huazhu.57fb61e1.jpg";